import React from 'react';
import { toast } from 'react-toastify';
import { ToastError } from '../ui/components/Toast';

const translateMsg = (err = '') => {
  // eslint-disable-next-line no-unused-vars
  const [code, msg] = err.split(':');

  switch (msg.trim()) {
    case 'The minimum length of title for search is 2':
    case 'The minimum length for search is 2':
      return 'La lunghezza minima per la ricerca è 2';
    case 'The minimum length for search is 3':
      return 'La lunghezza minima per la ricerca è 3';
    case 'The minimum length for search is 4':
      return 'La lunghezza minima per la ricerca è 4';

    default:
      break;
  }
};

export const minLengthToastId = 'minLengthToast';
export const errorHandling = (err) => {
  const msg = err?.data?.message || '';
  if (msg?.includes('minimum length')) {
    toast.error(<ToastError title="Attenzione!" body={translateMsg(msg)} />, {
      toastId: minLengthToastId,
    });
  }
  // else {
  //   toast.error(
  //     <ToastError title="Attenzione!" body="Qualcosa è andato storto..." />,
  //     {
  //       toastId: minLengthToastId,
  //     }
  //   );
  // }
};

export const genericErrToastId = 'genericErrToast';
export const genericErrorToast = (err) => {
  toast.error(
    <ToastError title="Attenzione!" body="Qualcosa è andato storto" />,
    {
      toastId: genericErrToastId,
    }
  );
};
